import React from 'react'

const footer = () => {
  return (
    <div
      className="text-center p-4"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.05)" }}
    >
      © 2023 Copyright :
      <a className="text-reset fw-bold" href="https://mdbootstrap.com/">
         <br></br>Om Kenge
      </a>
    </div>
  );
}

export default footer